import * as React from "react";
import Collapsible from "react-collapsible";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; import { faSave, faTimesCircle, faUndo } from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { dateFormatter2, downloadExcel, errorToastr, history, successToastr } from "../../../../HelperMethods";
import auth from "../../../Auth";
import { ErrorComponent } from "../../../ReusableComponents";
import { AppPermissions } from "../../../Shared/Constants/AppPermissions";
import { EXCEL_DOWNLOAD_INPROGRESS, NO_DATA_AVAILABLE_TO_GENERATE_REPORT } from "../../../Shared/AppMessages";
import reportServices from "../../../Shared/Services/ReportServices";
import { State } from "@progress/kendo-data-query";
import BreadCrumbs from "../../../Shared/BreadCrumbs/BreadCrumbs";

export interface CBIReportProps {
    props: any;
    match: any;
}

export interface CBIReportState {
    showLoader: boolean;
    clientId?: string;
    clientName?: string;
    startDate: Date;
    endDate: Date;
    extractType: any;
    flag?: boolean;
}

class CBIReport extends React.Component<CBIReportProps, CBIReportState> {

    constructor(props: CBIReportProps) {
        super(props);
        this.state = {
            clientId: localStorage.getItem("UserClientId"),
            clientName: auth.getClientName(),
            startDate: null,
            endDate: null,
            showLoader: false,
            extractType: null,
            flag: false
        };
    }

    componentDidMount() {
        this.restrictDatesEntry();
    }

    restrictDatesEntry = () => {
        if (document.getElementsByName('billingPeriodStartDate') && document.getElementsByName('billingPeriodStartDate')[0]) {
            document.getElementsByName('billingPeriodStartDate')[0]['disabled'] = true;
            document.getElementsByName('billingPeriodEndDate')[0]['disabled'] = true;
        }
    }
    handleBillingPeriodDate = (value, type) => {
       if(type=='startDate')
        {
            this.setState({
                startDate: value,
            })
        }else if(type=='endDate'){
            this.setState({
                endDate: value,
            })
        }
    }

    handleReset = () => {
        this.setState(
            {
                startDate: null,
                endDate: null,
                extractType: null
            }
        );
    };

    downloadCbiReportExcel = () => {

        var filterValidation = (this.state.extractType === null || this.state.startDate === null || this.state.endDate === null)
        if (filterValidation) {
            this.setState({ showLoader: false, })
            return false
        }

        var finalState: State = {
            take: null,
            skip: 0,
        };

        successToastr(EXCEL_DOWNLOAD_INPROGRESS);
        reportServices.getcbiReportExcelForExcel(null, null, finalState,
            dateFormatter2(new Date(this.state.startDate)),
            dateFormatter2(new Date(this.state.endDate)),
            this.state.extractType
        ).then((res: any) => {
            if (res) {
                if (res.data === null) {
                    errorToastr(NO_DATA_AVAILABLE_TO_GENERATE_REPORT);
                    return;
                }
                var fileName = this.state.extractType =="1" ? 'CI Accounting Export.xlsx' : 'CI Detail Export.xlsx';
                downloadExcel(fileName, res.data);
            }
        });
    }

    render() {
        const { startDate, endDate, extractType, flag } = this.state;
        const userTriggerName = (
            <span>
                Export CI Extracts
            </span>
        );
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3 mt-md-0">
                <div className="container-fluid mt-3 mb-3">
                    <div className="row pt-2 pb-2 mt-3 accordianTitleClr mx-auto mb-2">
                        <div className="col-6 m-0 fonFifteen paddingLeftandRight">
                            <BreadCrumbs></BreadCrumbs>
                        </div>
                    </div>
                </div>
                <div className="col-12 ml-0 mr-0">
                    <div className="row mb-2">
                        <div className="col-12 ml-0 mr-0 mb-4">
                            <Collapsible
                                trigger={userTriggerName}
                                accordionPosition="1"
                                open={true}
                            >
                                {this.state.showLoader &&
                                    Array.from({ length: 2 }).map((item, i) => (
                                        <div className="row mx-auto mt-2" key={i}>
                                            {Array.from({ length: 3 }).map((item, j) => (
                                                <div
                                                    className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1"
                                                    key={j}
                                                >
                                                    <Skeleton width={100} />
                                                    <Skeleton height={30} />
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                {!this.state.showLoader && (
                                    <div>
                                        <div className="row mt-0 mx-0">
                                            <div className="col-12 col-sm-3 mt-3">
                                                <label className="mb-0 font-weight-bold">Client</label>
                                                <input
                                                    type="text"
                                                    className="form-control mt-1"
                                                    disabled={true}
                                                    value={this.state.clientName}
                                                />
                                            </div>
                                            <div className="col-12 col-sm-3 mt-3">
                                                <label className="mb-1 font-weight-bold required">Billing Period Start Date</label>
                                                <DatePicker
                                                    className="form-control release-date-ddl kendo-Tabledatepicker"
                                                    format="MM/dd/yyyy"
                                                    name="billingPeriodStartDate"
                                                    value={startDate}
                                                    onChange={(e) =>
                                                        this.handleBillingPeriodDate(e.value,'startDate')
                                                    }
                                                    formatPlaceholder="formatPattern"
                                                    max={endDate ? new Date(new Date(endDate).setDate(new Date(endDate).getDate() - 1)) : new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                                                />
                                                 {(!startDate || startDate == undefined || startDate == null) && flag == true 
                                                 && <ErrorComponent message="Select billing period start date" />}
                                            </div>
                                            <div className="col-12 col-sm-3 mt-3">
                                                <label className="mb-1 font-weight-bold required">Billing Period End Date</label>
                                                <div id="ShowDatePickerIcon">
                                                    <DatePicker
                                                        className="form-control release-date-ddl kendo-Tabledatepicker"
                                                        format="MM/dd/yyyy"
                                                        name="billingPeriodEndDate"
                                                        value={endDate}
                                                        onChange={(e) =>
                                                            this.handleBillingPeriodDate(e.value,'endDate')
                                                        }
                                                        formatPlaceholder="formatPattern"
                                                        min={new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1))}
                                                    />
                                                    {(!endDate || endDate == undefined || endDate == null) && flag == true 
                                                    && <ErrorComponent message="Select billing period end date" />}
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 mt-3">
                                                <label className="mb-1 font-weight-bold required">Extract Type</label>
                                                <div className="row mx-0">
                                                    <div className="d-flex flex-column pt-2 w-100"> 
                                                        {auth.hasPermissionV2(AppPermissions.CI_ACCOUNTING_REPORT_EXCEL_EXPORTS) && (
                                                        <label className="container container_checkboxandradio radioBtnCustom font-weight-normal col-auto ml-0 mr-0 mb-2">
                                                            <input
                                                                type="radio"
                                                                value="1"
                                                                name="extractType"
                                                                onChange={(event) => {
                                                                    this.setState({ extractType: event.target.value });
                                                                }}
                                                                checked={extractType == 1 ? true : false}
                                                            />
                                                            CI Accounting
                                                            <span className="checkmark"></span>
                                                        </label>)}
                                                        {auth.hasPermissionV2(AppPermissions.CI_DETAIL_REPORT_EXCEL_EXPORTS) && (
                                                        <label className="container container_checkboxandradio radioBtnCustom font-weight-normal col-auto ml-0 mr-0 mb-0">
                                                            <input
                                                                type="radio"
                                                                value="2"
                                                                name="extractType"
                                                                onChange={(event) => {
                                                                    this.setState({ extractType: event.target.value });
                                                                }}
                                                                checked={extractType == 2 ? true : false}
                                                            />
                                                            CI Detail
                                                            <span className="checkmark"></span>
                                                        </label>)}
                                                        {(!extractType || extractType == undefined || extractType == null) && flag == true 
                                                    && <ErrorComponent message="Select extract type" />}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Collapsible>
                            <div className="modal-footer justify-content-center border-0 mt-3 mb-3">
                                <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                                    <button
                                        type="button"
                                        className="btn button button-close mr-2 shadow mb-2 mb-xl-0"
                                        onClick={() => history.push('/client/invoices')}
                                    >
                                        <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} />{" "}
                                        Close
                                    </button>
                                    <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0"
                                     onClick={() => this.handleReset()}>
                                        <FontAwesomeIcon icon={faUndo} className={"mr-1"} /> Clear
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn button button-bg mr-2 shadow mb-2 mb-xl-0"
                                        onClick={() =>
                                            {
                                                this.downloadCbiReportExcel()
                                                this.setState({ flag: true })
                                            }}>
                                        <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Export
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CBIReport;